type Meta = { alias: string; name: string };

export const meta: Meta = {
  alias: 'announcement-bar',
  name: 'Announcement Bar'
};
